import { enum_ } from "valibot"

/**
 * Represents the type of storage for input profiles
 */
export enum StorageKind {
  /** Built-in preset that cannot be modified */
  Preset = 1,
  /** User-created profile stored in localStorage */
  LocalStorage = 2,
}

export const StorageKindSchema = enum_(StorageKind, 'Invalid Storage Type')